import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useWorkflow, Workflow } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
  formLayout,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<Workflow>
      useData={useWorkflow}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
        formLayout,
      }}
    />
  );
};

export default Form;
